<template>
    <BaseTipsBlock :title="$t('tips_systems_panel.title')" :subtitle="$t('tips_systems_panel.subtitle')">
        <div class="gap-row-txs">
            <div class="system-row">
                <div class="qrw-label-lg bold">
                    Inside
                </div>

                <BaseBetaToggle :value="modes.inside" @input="v => setSystemEnabled('inside', v)" />
            </div>
            <!-- <BaseDivider dashed color="border-base-tertiary" />
            <div class="system-row">
                <div class="qrw-label-lg bold">
                    Takeaway
                </div>

                <BaseBetaToggle :value="modes.takeaway" @input="v => setSystemEnabled('takeaway', v)" />
            </div>
            <BaseDivider dashed color="border-base-tertiary" />
            <div class="system-row">
                <div class="qrw-label-lg bold">
                    Delivery
                </div>

                <BaseBetaToggle :value="modes.delivery" @input="v => setSystemEnabled('delivery', v)" />
            </div> -->
        </div>
    </BaseTipsBlock>
</template>

<style scoped>
.system-row {
    display: flex;
    justify-content: space-between;
    width: 100%;
    align-items: center;
}
</style>

<script>
import BaseTipsBlock from './BaseTipsBlock.vue';

export default {
    components: {
        BaseTipsBlock
    },
    methods: {
        setSystemEnabled (system, enabled) {
            this.$store.commit('setTipSystemEnabled', { system, enabled });
            this.$store.dispatch('saveCafe');
        }
    },
    computed: {
        cafe () {
            return this.$store.state.cafe;
        },
        modes () {
            return this.cafe.tips.modes;
        }
    }
}
</script>